import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const PortalContainerContext = /*#__PURE__*/ createContext(null);
export function PortalContainerProvider(param) {
    let { container, children } = param;
    return /*#__PURE__*/ _jsx(PortalContainerContext.Provider, {
        value: container,
        children: children
    });
}
export function usePortalContainer() {
    return useContext(PortalContainerContext);
}
